import type { SessionDto } from "@/api/types";

/** Where to go after signing in: `?next=` when it is a path on this site, else the first (personal) workspace. */
export function nextPath(params: URLSearchParams, s: Pick<SessionDto, "workspaces">): string {
	const next = params.get("next");
	if (next && next.startsWith("/") && !next.startsWith("//")) return next;
	const ws = s.workspaces.find((w) => w.kind === "personal") ?? s.workspaces[0];
	return ws ? `/w/${ws.slug}/` : "/signin";
}

/** Leave the auth screens for the app, or back: a different router (the workspace is the app's basename). */
export function go(path: string) {
	window.location.assign(path);
}
